<template>
  <div class="spinner-wrapper mt-5">
    <div class="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpinnerIOS",
};
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner {
  position: relative;
  width: 10px;
  height: 10px;
}

.spinner div {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 6px;
  background-color: #6c757d;
  border-radius: 2px;
  transform-origin: center center;
  animation: spinner-fade 1.2s linear infinite;
}

.spinner div:nth-child(1) { transform: rotate(0deg) translate(0, -7px); animation-delay: -1.1s; }
.spinner div:nth-child(2) { transform: rotate(30deg) translate(0, -7px); animation-delay: -1s; }
.spinner div:nth-child(3) { transform: rotate(60deg) translate(0, -7px); animation-delay: -0.9s; }
.spinner div:nth-child(4) { transform: rotate(90deg) translate(0, -7px); animation-delay: -0.8s; }
.spinner div:nth-child(5) { transform: rotate(120deg) translate(0, -7px); animation-delay: -0.7s; }
.spinner div:nth-child(6) { transform: rotate(150deg) translate(0, -7px); animation-delay: -0.6s; }
.spinner div:nth-child(7) { transform: rotate(180deg) translate(0, -7px); animation-delay: -0.5s; }
.spinner div:nth-child(8) { transform: rotate(210deg) translate(0, -7px); animation-delay: -0.4s; }
.spinner div:nth-child(9) { transform: rotate(240deg) translate(0, -7px); animation-delay: -0.3s; }
.spinner div:nth-child(10) { transform: rotate(270deg) translate(0, -7px); animation-delay: -0.2s; }
.spinner div:nth-child(11) { transform: rotate(300deg) translate(0, -7px); animation-delay: -0.1s; }
.spinner div:nth-child(12) { transform: rotate(330deg) translate(0, -7px); animation-delay: 0s; }

@keyframes spinner-fade {
  0% { opacity: 1; }
  100% { opacity: 0.1; }
}
</style>
